import { useMemo } from 'react'

import { useAppSelector } from '@store/hooks'
import { selectCurrentUser } from '@store/modules/session/slice'

export const authorizedRoles = [
  'admin',
  'risk',
  'super_admin',
  'senior_risk',
  'operations',
  'senior_operations',
  'finance',
  'sales',
]

/*
  useRole hook used for: 
  - check if user has admin or super_admin role (isAdmin, isSuperAdmin)

  Example:
  const { isAdmin, isSuperAdmin } = useRole()
*/
export function useRole() {
  const user = useAppSelector(selectCurrentUser)

  const checkIsAuthorized = (role: string) => authorizedRoles.includes(role)

  // User roles
  const role = user?.role ?? ''
  const isAdmin = role === 'admin'
  const isSuperAdmin = role === 'super_admin'

  const isAuthorized = checkIsAuthorized(role)

  return useMemo(
    () => ({
      user,

      isAdmin,
      isSuperAdmin,

      checkIsAuthorized,
      isAuthorized,
    }),
    [isAdmin, isAuthorized, isSuperAdmin, user],
  )
}
